export const SUPERUSERLEVELS_KH_LA = [
  {
    levelname: "Super User",
    columnName: "Super User",
    emailId: "",
    active: false,
  },
  {
    levelname: "RSM",
    columnName: "Branch Manager",
    emailId: "",
    active: true,
  },
  {
    levelname: "Area Sales Manager",
    columnName: "Area Sales Manager",
    emailId: "",
    active: false,
  },
  {
    levelname: "Sales Manager",
    columnName: "Supervisor",
    emailId: "",
    active: false,
  },
  {
    levelname: "Supervisor",
    columnName: "TeamLeader",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    columnName: "Salesman",
    emailId: "",
    active: false,
  },
];

export const CDVPLEVELS_KH_LA = [
  {
    levelname: "CD VP",
    columnName: "CD VP",
    emailId: "",
    active: false,
  },
  {
    levelname: "RSM",
   columnName: "Branch Manager",
    emailId: "",
    active: true,
  },
  {
    levelname: "Area Sales Manager",
    columnName: "Area Sales Manager",
    emailId: "",
    active: false,
  },
  {
    levelname: "Supervisor",
    columnName: "Sales Supervisor",
    emailId: "",
    active: false,
  },
  {
    levelname: "Supervisor",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    columnName: "Salesman",
    emailId: "",
    active: false,
  },
];

export const BMLEVELS_KH_LA = [
  {
    levelname: "RSM",
    columnName: "Branch Manager",
    emailId: "",
    active: false,
  },
  {
    levelname: "Area Sales Manager",
    columnName: "Area Sales Manager",
    emailId: "",
    active: true,
  },
  {
    levelname: "Supervisor",
    columnName: "Sales Supervisor",
    emailId: "",
    active: false,
  },
  {
    levelname: "Team Leader",
    columnName: "Team Lead",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const ASMLEVELS_KH_LA = [
  {
    levelname: "Area Sales Manager",
    columnName: "Area Sales Manager",
    emailId: "",
    active: false,
  },
  {
    levelname: "Supervisor",
    columnName: "Sales Supervisor",
    emailId: "",
    active: true,
  },
  {
    levelname: "Team Leader",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const SUPLEVELS_KH_LA = [
  {
    levelname: "Supervisor",
    columnName: "Sales Supervisor",
    emailId: "",
    active: false,
  },
  {
    levelname: "Team Leader",
    columnName: "Team Leads",
    emailId: "",
    active: true,
  },
  {
    levelname: "Salesrep",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const DTLEVELS_KH_LA = [
  {
    levelname: "DT Operator",
    columnName: "DT Operator",
    emailId: "",
    active: false,
  },
  {
    levelname: "Team Leader",
    columnName: "Team Leads",
    emailId: "",
    active: true,
  },
  {
    levelname: "Salesrep",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const TLLEVELS_KH_LA = [
  {
    levelname: "Team Leader00",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep88",
    columnName: "Salesrep",
    emailId: "",
    active: true,
  },
];

export const SUPERUSERDISTRIBUTORlEVELS_KH_LA = [
  {
    levelname: "Super User88",
    role: "Super User88",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor99",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "Team Leader",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    role: "LEVEL4",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const CDVPDISTRIBUTORlEVELS_KH_LA = [
  {
    levelname: "CD VP",
    role: "CD VP",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "Team Leader",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    role: "LEVEL4",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const BMDISTRIBUTORlEVELS_KH_LA = [
  {
    levelname: "Branch Manager",
    role: "Branch Manager",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "Team Leader",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    role: "LEVEL4",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const ASMDISTRIBUTORlEVELS_KH_LA = [
  {
    levelname: "Area Sales Manager",
    role: "Area Sales Manager",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "Team Leader",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    role: "LEVEL4",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const SUPDISTRIBUTORlEVELS_KH_LA = [
  {
    levelname: "Supervisor",
    role: "Supervisor",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "Team Leader",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    role: "LEVEL4",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const DTOPERATORLEVELS_KH_LA = [
  {
    levelname: "DT Operator",
    role: "DT Operator",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "Team Leader",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesrep",
    role: "LEVEL4",
    columnName: "Salesrep",
    emailId: "",
    active: false,
  },
];

export const getLevelsKhLa = (role) => {
  switch (role) {
    case "Super User": return SUPERUSERLEVELS_KH_LA;
    case "CD VP": return CDVPLEVELS_KH_LA;
    case "Branch Manager": return BMLEVELS_KH_LA;
    case "Area Sales Manager": return ASMLEVELS_KH_LA;
    case "Supervisor": return SUPLEVELS_KH_LA;
    case "DT Operator": return DTLEVELS_KH_LA;
    case "Team Leader": return TLLEVELS_KH_LA;
    default: return CDVPLEVELS_KH_LA;
  }
};

export const getDistributorLevelsKhLa = (role) => {
  switch (role) {
    case "Super User": return SUPERUSERDISTRIBUTORlEVELS_KH_LA;
    case "CD VP": return CDVPDISTRIBUTORlEVELS_KH_LA;
    case "Branch Manager": return BMDISTRIBUTORlEVELS_KH_LA;
    case "Area Sales Manager": return ASMDISTRIBUTORlEVELS_KH_LA;
    case "Supervisor": return SUPDISTRIBUTORlEVELS_KH_LA;
    case "DT Operator": return DTOPERATORLEVELS_KH_LA;
    default: return CDVPDISTRIBUTORlEVELS_KH_LA;
  }
};
